import { Link } from "react-router-dom";

import { routes } from "@/common/utils/routes";
import DEFAULT_USERPIC from "@/common/images/icons/profileIcon.svg";
import { INiche } from "@/common/services/types";

import { Image } from "@/components/UI/Image";

import "./NichePreviewAvatar.scss";
import { useSfw } from "@/common/hooks/useSfw";

interface IProps {
  niche: INiche;
  onPreviewClick?: () => void;
}

export const NichePreviewAvatar = (props: IProps) => {
  const { sanitizeNiche, isLoading } = useSfw();
  const niche = sanitizeNiche(props.niche);

  if (isLoading) {
    return null;
  }

  return (
    <Link className="NichePreviewAvatar" to={routes.niche(niche.id)} onClick={props.onPreviewClick} aria-label={`Link to ${niche.name} niche`}>
      <Image src={niche.thumbnail ?? DEFAULT_USERPIC} alt={`Avatar for ${niche.name} niche`} />
    </Link>
  );
};
